<template>
<div id="zttj">
    <header class="head mod">
        <input type="text" class="mdate"  :value="nowDate" @input="initCalendar($event.target.value,1)" readonly>
    </header>
    <section class="mod clearfix">
        <div class="tj-item fl">
            <p class="up">共涨停<span>{{zdttjInfo.ZhangTing}}</span></p>
            <p class="down">共跌停<span>{{zdttjInfo.DieTing}}</span></p>
        </div>
        <div class="tj-item fl">
            <p class="up">涨5%以上<span>{{zdttjInfo.ShangZhang5}}</span></p>
            <p class="down">跌5%以上<span>{{zdttjInfo.XiaDie5}}</span></p>
        </div>
    </section>
    <section class="mod">
        <h2 class="mod-tit">板块强度
            <p class="fr">
                <span v-for="(item,index) in bkqdTabs" :class="{'cur':bkqdCurTab==index}"> <!--@click="bkqdCurTab=index,bkqdTabChange(index)"-->{{item}}</span>
            </p>
        </h2>
        <div class="chart" style="height: 3.8rem;" id="bkqd-echart-container"><p class="blank">- 暂无数据 -</p></div>
        <div class="chart" style="height: 3.8rem; display: none" id="bkqd-echart-container-blank"><p class="blank">- 暂无数据 -</p></div>
        <div style="padding: 0.16rem 0.15rem 0.6rem 0.15rem;"><div v-for="(rate, index) in axisRates" style="width:20%;float:left;text-align:center;font-size:0.24rem;" @click="goBlockTimeline(index)"><p :style="rate | colorFormat">{{rate ? rate+'%':'--'}}</p></div></div>
    </section>
    <section class="mod">
        <div class="mod-nav">
            <nav class="nav fl"><span :class="{'cur':curNav==index}" v-for="(item,index) in navs" @click="changeCurNav(index)">{{item}}</span></nav>
            <span class="btn-switch" :class="{'block':toggleShow}" @click="toggleShow=!toggleShow"></span>
        </div>
        <div class="nav-content" v-for="(content,index) in navContents" v-if="curNav==index && navContents.length>0">
            <div class="table-wrap" v-show="!toggleShow&&!noData">
                <div class="table-l">
                    <div class="table-hd"><span class="filter" @click="filterFun(-1,content.upTopStock)" :class="{'up':content.upTopStock.filterCount==1,'down':content.upTopStock.filterCount==-1}">股票</span></div>
                    <ul class="table-bd">
                        <li v-for="item in content.tableList"><span class="td-stock" @click="goStockDetail(item.obj,item.ZhongWenJianCheng)"><div>{{item.ZhongWenJianCheng}}</div><small>{{item.obj}}</small></span></li>
                    </ul>
                </div>
                <div class="table-r">
                    <div class="table-r-scroll table-zttj">
                        <div class="table-hd">
                            <span class="filter" v-if="item.title != '所属板块' && item.title != '涨停原因'" v-for="(item,index) in content.rTableHeads" :class="{'up':item.filterCount==1,'down':item.filterCount==-1}" @click="filterFun(index,item)">{{item.title}}</span>
                            <span v-if="item.title == '所属板块'" v-for="(item,index) in content.rTableHeads">{{item.title}}</span>
                            <span v-if="item.title == '涨停原因' && showReason" v-for="(item,index) in content.rTableHeads">{{item.title}}</span>
                        </div>
                        <ul class="table-bd">
                            <li v-for="(item,index) in content.tableList">
                                <span><div v-html="item.ShouPanJia==null?'--':item.ShouPanJia.toFixed(2)"></div><small></small></span>
                                <span><div v-if="item.ZhangTingShiJian!=null">{{item.ZhangTingShiJian*1000 | dataFormat('hh:mm')}}</div><div v-else>--</div><small></small></span>
                                <span><div v-html="item.LianBan==null?'--':item.LianBan"></div><small></small></span>
                                <span><div v-html="item.FengDanLiangZhanBi==null?'--':item.FengDanLiangZhanBi+'%'"></div><small></small></span>
                                <span><div :class="{'font-red':item.DangRiHuanShouLv>0,'font-green':item.DangRiHuanShouLv<0}" v-html="item.DangRiHuanShouLv==null || item.DangRiHuanShouLv==undefined?'--':item.DangRiHuanShouLv+'%'"></div><small></small></span>
                                <span v-html="item.KaiBan==null?'--':item.KaiBan"><small></small></span>
                                <span><div>{{ item.ChengJiaoLiang | unitS}}</div><small></small></span>
                                <span><div>{{ item.ChengJiaoJinE| unitM}}</div><small></small></span>
                                <span><div :class="{'font-red':item.CiRiZhangFu>0,'font-green':item.CiRiZhangFu<0}" v-html="item.CiRiZhangFu==null?'--':item.CiRiZhangFu.toFixed(2)+'%'"></div><small></small></span>
                                <span style="font-size: 0.28rem;"><div v-html="item.blockInfo"></div><small></small></span>
                                <span v-if="showReason"><div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :style="reasons[item.obj] ? 'color:#0e49d5;':''" @click="showPop(item.obj)">{{reasons[item.obj] ? reasons[item.obj]: '--'}}</div><small></small></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="pop-win" :class="{'show':popShow}">
                <p>{{reasons[curSelectObj] ? reasons[curSelectObj]:''}}</p>
                <a @click="popShow=false">知道了</a>
            </div>
            <div class="list-wrap" v-if="toggleShow&&!noData">
                <div class="list-item" v-for="(item, idx) in content.tableList">
                    <h3 class="list-item-tit"><a style="color: #0e49d5" @click="goStockDetail(item.obj,item.ZhongWenJianCheng)">{{item.ZhongWenJianCheng}}</a>&nbsp;&nbsp;<a style="font-size: 0.28rem;color:gray">{{item.obj}}</a></h3>
                    <ul class="list-item-cont">
                        <li>收盘价<span v-html="item.ShouPanJia==null?'--':item.ShouPanJia.toFixed(2)"></span></li>
                        <li>成交量<span>{{ item.ChengJiaoLiang | unitS}}</span></li>
                        <li>换手率<span v-html="item.DangRiHuanShouLv==null || item.DangRiHuanShouLv==undefined?'--':item.DangRiHuanShouLv+'%'"></span></li>
                        <li>成交金额<span>{{ item.ChengJiaoJinE| unitM}}</span></li>
                        <li>涨停时间<span v-if="item.ZhangTingShiJian!=null">{{item.ZhangTingShiJian*1000 | dataFormat('hh:mm')}}</span> <span v-else>--</span></li>
                        <li>开板次数<span v-html="item.KaiBan==null?'--':item.KaiBan"></span></li>
                        <li>封单占流通比<span v-html="item.FengDanLiangZhanBi==null?'--':item.FengDanLiangZhanBi+'%'"></span></li>
                        <li>连板<span v-html="item.LianBan==null?'--':item.LianBan"></span></li>
                        <li>次日涨幅<span :class="{'font-red':item.CiRiZhangFu>0,'font-green':item.CiRiZhangFu<0}" v-html="item.CiRiZhangFu==null?'--':item.CiRiZhangFu.toFixed(2)+'%'"></span></li>
                        <li style="width: 100%">所属板块<span v-html="item.blockInfo"></span></li>
                    </ul>
                    <div v-if="showReason" class="reason clearfix">涨停原因<div @click="showReasonMore(index, idx)"><p :class="{'more':item.isMore}">{{reasons[item.obj] ? reasons[item.obj]: '--'}}</p></div></div>
                </div>
            </div>
            <p class="blank" v-if="noData">- 暂无数据 -</p>
        </div>
        <div class="mod-help">数据于交易日收盘后更新</div>
    </section>
    <div class="banner" style="display: none" @click="downloadApp"><span>打开大智慧免费查看更多数据</span></div>
    <div class="footer">
        <p>【免责声明】本公司力求数据准确性，如有错漏请以证监会指定上市公司披露媒体为准。本公司不因对该资料产生或引起的任何损失承担任何责任。</p>
    </div>
</div>
</template>
<script>
import date from '@/utils/date.js'
import {share} from '@/utils/dzh'
import wxshare from '@/utils/wxshare'
import axios from 'axios'
export default {
  name: 'Calendar',
  data () {
    return {
        isWeixin:false,
        curSelectObj:'',
        popShow:false,
        calendar:[],
        nowDate:'',
        query:{date:''},
        zdttjInfo:{DieTing: "--", FeiYiZiZhangTing: "--",RiQi: "--", ShangZhang5: "--", XiaDie5: "--", ZhangTing: "--"},
        // bkqdTabs:['按涨停数量','按启动顺序'],
        bkqdTabs:['板块成分股涨停家数'],
        bkqdCurTab:0,
        chartData:{xAxisData:[],yAxisData:{zt:[],zf:[],zf_min:0,zf_max:0}},
        noData:true,
        curNav:0,
        toggleShow:true,
        charts: null,
        blockCodes:{},
        reasons: {}, //涨停原因
        showReason: true,
        axisRates:[], //x坐标下方张福
        navs:['自然板','一字板','ST板'],
        headers:['obj','ShouPanJia','ZhangTingShiJian','LianBan','FengDanLiangZhanBi','DangRiHuanShouLv','KaiBan','ChengJiaoLiang','ChengJiaoJinE','CiRiZhangFu','SuoShuBanKuai','ZhangTingYuanYin'],
        navContents:[
            {
                init: false,
                tableList:[],
                upTopStock:{ filterCount:0 },
                rTableHeads:[
                    {title:'收盘价',filterCount:0},
                    {title:'涨停时间',filterCount:0},
                    {title:'连板',filterCount:0},
                    {title:'封单占流通比',filterCount:0},
                    {title:'换手率',filterCount:0},
                    {title:'开板次数',filterCount:0},
                    {title:'成交量',filterCount:0},
                    {title:'成交金额',filterCount:0},
                    {title:'次日涨幅',filterCount:0},
                    {title:'所属板块',filterCount:0},
                    {title:'涨停原因',filterCount:0}
                ]
            },
            {
                init: false,
                tableList:[],
                upTopStock:{ filterCount:0 },
                rTableHeads:[
                    {title:'收盘价',filterCount:0},
                    {title:'涨停时间',filterCount:0},
                    {title:'连板',filterCount:0},
                    {title:'封单占流通比',filterCount:0},
                    {title:'换手率',filterCount:0},
                    {title:'开板次数',filterCount:0},
                    {title:'成交量',filterCount:0},
                    {title:'成交金额',filterCount:0},
                    {title:'次日涨幅',filterCount:0},
                    {title:'所属板块',filterCount:0},
                    {title:'涨停原因',filterCount:0}
                ]
            },
            {
                init: false,
                tableList:[],
                upTopStock:{ filterCount:0 },
                rTableHeads:[
                    {title:'收盘价',filterCount:0},
                    {title:'涨停时间',filterCount:0},
                    {title:'连板',filterCount:0},
                    {title:'封单占流通比',filterCount:0},
                    {title:'换手率',filterCount:0},
                    {title:'开板次数',filterCount:0},
                    {title:'成交量',filterCount:0},
                    {title:'成交金额',filterCount:0},
                    {title:'次日涨幅',filterCount:0},
                    {title:'所属板块',filterCount:0},
                    {title:'涨停原因',filterCount:0}
                ]
            }
        ],
        xAxisBlockRate: ''
    }
  },
  created(){
      var _this=this
      document.title = "涨停统计";
      let   nowDate=date.formt(new Date(Date.now()), "yyyy-MM-dd");
      let   startDate;
      let   endDate;
      startDate = date.formt(new Date(Date.now()-365*24*60*60*1000), "yyyyMMdd");
      if(new Date()>new Date(Date.parse(nowDate+' 15:05:00')) && new Date()<new Date(Date.parse(nowDate+' 15:15:00'))){
          dzhyun.query('/limitup/trend', {date: date.formt(new Date(Date.now()), "yyyyMMdd")}, function (data) {
              //...
          }).then(function (data) {
              //...
              if(nowDate==_this.nowDate && data==undefined){
                  endDate = date.formt(new Date(Date.now()-24*60*60*1000), "yyyy-MM-dd");
              }else{
                  endDate = date.formt(new Date(Date.now()), "yyyy-MM-dd");
              }
              dzhyun.query('/market/calendar', {
                  market: 'SH',
                  begindate: startDate,
                  enddate: endDate.replace(/-/g, '')
              }, function (calendar) {

              }).then(function (calendar) {
                  _this.calendar = calendar[0].TradeDate;
                  $('.mdate').mdater({
                      availableDate : calendar[0].TradeDate,
                  });
                  let initDate
                  let str=calendar[0].TradeDate[calendar[0].TradeDate.length-1]
                  initDate=str.slice(0,4)+"-"+str.slice(4,6)+"-"+str.slice(6,8);
                  _this.initCalendar(initDate,0);
              });
          }).catch(function (err) {
              //...
          })
      }else{
          let   myTime=nowDate+' 15:05:00';
          myTime   = myTime.replace(/-/g,"/");//替换字符，变成标准格式
          let d1  = new Date();//取今天的日期
          let d2  = new Date(Date.parse(myTime));
          if(d1>d2){
             endDate = date.formt(new Date(Date.now()), "yyyy-MM-dd");
          }else{
             endDate = date.formt(new Date(Date.now()-24*60*60*1000), "yyyy-MM-dd");
          }
          dzhyun.query('/market/calendar', {
              market: 'SH',
              begindate: startDate,
              enddate: endDate.replace(/-/g, '')
          }, function (calendar) {

          }).then(function (calendar) {
              _this.calendar = calendar[0].TradeDate;
              $('.mdate').mdater({
                  availableDate : calendar[0].TradeDate,
              });
              let initDate
              let str=calendar[0].TradeDate[calendar[0].TradeDate.length-1]
              initDate=str.slice(0,4)+"-"+str.slice(4,6)+"-"+str.slice(6,8);
              _this.initCalendar(initDate,0);
          });
      }
      var ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          this.isWeixin= true;
      }else{
          this.isWeixin= false;
      }
      wxshare.do(this.$route.fullPath,'http://static.yundzh.com/logo.png','涨停分析');
  },
  mounted:function(){
    share("涨停分析",this.$route.fullPath);
    var _this = this;
    $(".mod").delegate(".blockInfo","click",function(){
        var blockName = $(this).text();
        if(_this.blockCodes.hasOwnProperty(blockName)) {
            var blockCode = _this.blockCodes[blockName].replace("$", "I");
            window.location.href = 'dzh_browser_url&goto=0&type=2955&kind=0&code='+blockCode
        }
    });
      var ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          $('.banner').show();
      }
  },
  filters:{
    unitS: function (num) {
        var moneyUnits = ["股","万","亿","万亿"]
        var dividend = 10000
        var curentNum = num //转换数字
        var curentUnit = moneyUnits[0] //转换单位
        for (var i = 0; i < 3; i++) {
            curentUnit = moneyUnits[i]
            var stringNum = curentNum.toString()
            var index = stringNum.indexOf(".")
            var newNum = stringNum
            if(index!=-1){ newNum = stringNum.substring(0,index) }

            if (newNum.length < 5) {
                break;
            }
            curentNum = curentNum / dividend
        }
        var m = {num: 0, unit: ""}
        m.num = Number(curentNum).toFixed(2)
        m.unit = curentUnit
        return m.num + m.unit
    },
    unitM: function (num) {
        var moneyUnits = ["元","万", "亿", "万亿"]
        var dividend = 10000
        var curentNum = num //转换数字
        var curentUnit = moneyUnits[0] //转换单位
        for (var i = 0; i < 3; i++) {
            curentUnit = moneyUnits[i]
            var stringNum = curentNum.toString()
            var index = stringNum.indexOf(".")
            var newNum = stringNum
            if(index!=-1){ newNum = stringNum.substring(0,index) }

            if (newNum.length < 5) {
                break;
            }
            curentNum = curentNum / dividend
        }
        var m = {num: 0, unit: ""}
        m.num = Number(curentNum).toFixed(2)
        m.unit = curentUnit
        return m.num + m.unit
    },
    dataFormat:function (value, fmt) {
        let getDate = new Date(value);
        let o = {
            'M+': getDate.getMonth() + 1,
            'd+': getDate.getDate(),
            'h+': getDate.getHours(),
            'm+': getDate.getMinutes(),
            's+': getDate.getSeconds(),
            'q+': Math.floor((getDate.getMonth() + 3) / 3),
            'S': getDate.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (let k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
        }
        return fmt;
    },
    colorFormat(value) {
      if(value == null || value == undefined || value == '' || isNaN(value)) {
          return ''
      }
      if(parseFloat(value) > 0) {
          return 'color:red'
      } else if(parseFloat(value) < 0) {
          return 'color:green'
      }
    }
  },
  methods: {
      downloadApp:function() {
          window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.android.dazhihui'
      },
      showPop:function(obj){
          if(this.reasons.hasOwnProperty(obj)) {
              this.popShow = true;
              this.curSelectObj = obj;
          }
      },
      showReasonMore:function(index, idx) {
          this.$set(this.navContents[index].tableList[idx], 'isMore', !this.navContents[index].tableList[idx].isMore)
      },
      initCalendar: function (e,type) {
          let _this = this;
          _this.nowDate = e;
          _this.query.date = _this.nowDate.replace(/-/g, '');
          dzhyun.query('/limitup/trend', {date:  _this.query.date}, function (data) {
              //...
          }).then(function (data) {
              _this.handleInitCalendarSucc(data);
          }).catch(function (err) {
              //...
          })
      },
      handleInitCalendarSucc: function (res) {
          if (res != undefined && res.length > 0) {
              this.query.date = date.formt(new Date(res[0].RiQi * 1000), "yyyyMMdd")
              this.zdttjInfo = res[0];
          } else {
              this.zdttjInfo = {
                  DieTing: "--",
                  FeiYiZiZhangTing: "--",
                  RiQi: "--",
                  ShangZhang5: "--",
                  XiaDie5: "--",
                  ZhangTing: "--"
              };
          }
          this.getLimitupBlocktrengthInfo();//板块强度
          this.navContents[0].init = false;
          this.navContents[1].init = false;
          this.navContents[2].init = false;
          this.navContents[0].tableList = [];
          this.navContents[1].tableList = [];
          this.navContents[2].tableList = [];
          this.axisRates = [];
          this.getLimitupMarketData(this.curNav);
      },
      bkqdTabChange:function(index){
          var _this=this;
          setTimeout(function(){
              _this.bkqdCurTab = index;
              _this.chartData = {xAxisData:[],yAxisData:{zt:[],zf:[],zf_min:0,zf_max:0}};
              let orderby;
              switch(index)
              {
                  case 0:
                      orderby='count'
                      break;
                  case 1:
                      orderby='time'
                      break;
                  default:
              }
              _this.getLimitupBlocktrengthInfo(orderby);
          },300);
      },
      getLimitupBlocktrengthInfo: function (orderby) {
          var _this = this;
          document.getElementById("bkqd-echart-container").style.display="none";
          document.getElementById("bkqd-echart-container-blank").style.display = "block";
          /*
          if((this.chartData.yAxisData.zt.length>0  || this.chartData.yAxisData.zf.length>0)) {
              document.getElementById("bkqd-echart-container-blank").style.display = "block";
          }else{
              document.getElementById("bkqd-echart-container-blank").style.display = "none";
          }
          */
          dzhyun.query('/limitup/blocktrength', {date: _this.query.date, orderby: orderby, top:30}, function (data) {
              //...
          }).then(function (data) {
              _this.handleGetLimitupBlocktrengthSucc(data);
          }).catch(function (err) {
              //...
          });
      },
      handleGetLimitupBlocktrengthSucc: function (res) {
          let filterCodes = ['993070', '993405', '993124', '993130', '993139', '993140', '993141', '993505', '993806', '993885', '993996', '998000', '998001', '998002', '998003', '993503', '993752', '993625', '993386', '993703']
          //console.log(res)
          let cnt = 0
          if (res.length > 0 && res[0].BanKuaiQiangDu !=undefined  && res[0].BanKuaiQiangDu.length>0) {
              for(var i=0;i<res[0].BanKuaiQiangDu.length;i++) {
                  let code = res[0].BanKuaiQiangDu[i].Obj
                  let flag = 0
                  for(var j=0;j<filterCodes.length;j++) {
                      if(code.substring(2,8) === filterCodes[j]) {
                          flag = 1
                          break
                      }
                  }
                  if(flag) {
                      continue
                  } else {
                      if(cnt === 5) {
                          break
                      }
                  }
                  this.chartData.yAxisData.zt[cnt] = res[0].BanKuaiQiangDu[i].ZhangTing;
                  this.chartData.yAxisData.zf[cnt] = res[0].BanKuaiQiangDu[i].ZhangFu;
                  this.chartData.xAxisData[cnt] = res[0].BanKuaiQiangDu[i].ZhongWenJianCheng;
                  if(!this.blockCodes.hasOwnProperty(res[0].BanKuaiQiangDu[i].ZhongWenJianCheng)) {
                      this.blockCodes[res[0].BanKuaiQiangDu[i].ZhongWenJianCheng] = res[0].BanKuaiQiangDu[i].Obj;
                  }
                  if( res[0].BanKuaiQiangDu[i].ZhangFu > this.chartData.yAxisData.zf_max) {
                      this.chartData.yAxisData.zf_max =  res[0].BanKuaiQiangDu[i].ZhangFu;
                  }
                  if( res[0].BanKuaiQiangDu[i].ZhangFu < this.chartData.yAxisData.zf_min) {
                      this.chartData.yAxisData.zf_min =  res[0].BanKuaiQiangDu[i].ZhangFu;
                  }
                  cnt += 1
              }
          } else {
              this.chartData={xAxisData:[],yAxisData:{zt:[],zf:[],zf_min:0,zf_max:0}};
          }

          if((this.chartData.yAxisData.zt.length>0  || this.chartData.yAxisData.zf.length>0)){
              document.getElementById("bkqd-echart-container").style.display="block";
              document.getElementById("bkqd-echart-container-blank").style.display="none";
              this.myChart();
          }else{
              document.getElementById("bkqd-echart-container").style.display="none";
              document.getElementById("bkqd-echart-container-blank").style.display="block";
          }
      },
      goStockDetail:function(code,codeName) {
          //this.$router.push('/index/'+code+'/'+codeName+"?&DZHSPECIAL=257");
          window.location.href='#/index/'+code+'/'+codeName+"?DZHSPECIAL=1"
      },
      goBlockTimeline:function(index) {
          var name = this.chartData.xAxisData[index];
          if(this.isWeixin){
              window.location.href="http://android.myapp.com/myapp/detail.htm?apkName=com.android.dazhihui"
          }else if(this.blockCodes.hasOwnProperty(name)) {
              var blockCode = this.blockCodes[name].replace("$", "I");
              window.location.href='dzh_browser_url&goto=0&type=2970&kind=1&code='+blockCode;
          }
      },
      blockFormat:function (blockStr) {
          var blocks = blockStr.split(',')
          var html = ''
          for(var i=0;i<blocks.length;i++) {
              if(navigator.userAgent.indexOf('hmos') > 0) {
                  if(html == '') {
                      html = '<a class="blockInfo">'+blocks[i]+'</a>'
                  } else {
                      html += ',<a class="blockInfo">'+blocks[i]+'</a>'
                  }
              } else {
                  if(html == '') {
                      html = '<a class="blockInfo" style="color: #0e49d5">'+blocks[i]+'</a>'
                  } else {
                      html += ',<a class="blockInfo" style="color: #0e49d5">'+blocks[i]+'</a>'
                  }
              }
          }
          return html
      },
      myChart:function() {
          let _this=this;
          let charts = echarts.init(document.getElementById('bkqd-echart-container'),'white');
          let option = {
              color:['#4F92F3','#ffc675'],
              // tooltip: {
              //     trigger: 'axis',
              //     backgroundColor: '#c6c9cd',
              //     axisPointer: {
              //         //type: 'cross',
              //         crossStyle: {
              //             color: '#999'
              //         }
              //     }
              // },
              /*
              legend: {
                  selectedMode:false,//取消图例上的点击事件,
                  orient: 'vertical',
                  x: 'right',
                  data:['板块成分股涨停家数'],
                  itemWidth: 20
              },
              */
              grid: {
                  left: '2%',
                  right: '2%',
                  bottom: '2%',
                  top:'30',
                  containLabel: true,
                 // show:true, //边框
                  borderWidth:1,
              },
              xAxis: [
                  {
                      triggerEvent: true,
                      type: 'category',
                      show: true,
                      axisLabel: {
                          interval: 0,
                          rotate:0,
                          textStyle: {fontSize: 12},
                          formatter : function(params){
                              var newParamsName = "";
                              var paramsNameNumber = params.length;
                              var provideNumber = 4;
                              if (paramsNameNumber > provideNumber) {
                                  newParamsName = params.substring(0, 4);
                                  newParamsName += "...";
                              } else {
                                  newParamsName = params;
                              }
                              return newParamsName
                          }
                      },
                      boundaryGap: true,
                      axisLine:{
                          show: false,
                          lineStyle:{
                              color:'#c6c9cd',
                              width:1,
                              type:'solid',
                          }
                      },
                      data: _this.chartData.xAxisData,
                  }
              ],
              yAxis: [
                  {
                      type: 'value',
                      splitLine:{
                          show:false
                      },
                      splitNumber: 2,
                      axisLabel: false
                  },
                  // {
                  //     type: 'value',
                  //     splitLine:{
                  //         show: false
                  //     },
                  //     min: Math.ceil(_this.chartData.yAxisData.zf_min-1),
                  //     max: Math.ceil(_this.chartData.yAxisData.zf_max+1),
                  //     interval: 5,
                  //     axisLabel: false
                  // }
              ],
              series: [
                  {
                      name:'板块成分股涨停家数',
                      type:'bar',
                      barWidth:20,
                      data:_this.chartData.yAxisData.zt,
                      itemStyle : {
                          normal: {
                              label : {
                                  show: true,
                                  position: 'top'
                              }
                          }
                      },
                  },
                  // {
                  //     name:'涨幅(%)',
                  //     type:'line',
                  //     yAxisIndex: 1,
                  //     data:_this.chartData.yAxisData.zf
                  // }
              ]
          };
          charts.setOption(option);
          if(this.charts == null) {
              charts.on('click',function (params) {
                  if(params.componentType =="xAxis" || params.targetType =="axisLabel" ){
                      var blockName = params.value
                      if(_this.isWeixin){
                        window.location.href="http://android.myapp.com/myapp/detail.htm?apkName=com.android.dazhihui"
                      }else if(_this.blockCodes.hasOwnProperty(blockName)) {
                          var blockCode = _this.blockCodes[blockName].replace("$", "I")
                          window.location.href='dzh_browser_url&goto=0&type=2970&kind=1&code='+blockCode;
                      }
                  }
              });
          } else {
              this.charts = charts;
          }
          this.axisRates = this.chartData.yAxisData.zf
      },
      changeCurNav: function (index) {
          if(this.navContents[index].init == false) {
              this.getLimitupMarketData(index)
          } else {
              this.curNav = index
              this.noData=false;
          }
      },
      getLimitupMarketData:function(index) {
          let tp = 'ziran'
          if(index == 1) {
              tp = 'yizi'
          } else if(index == 2) {
              tp = 'st'
          }
          var _this = this;
          dzhyun.query('/limitup/marketdata', {
              date: _this.query.date,
              type: tp,
              orderby:'ztsj',
              desc:true,
              start: 0,
              count: 500,
          }, function (data) {
              //...
          }).then(function (data) {
              _this.handleGetLimitupMarketDataSucc(data, index);
          }).catch(function (err) {
              //...
          });
      },
      handleGetLimitupMarketDataSucc: function (res, index) {
          if (res.length > 0 && res[0].ZhangTingShuJu!=undefined && res[0].ZhangTingShuJu.length>0) {
              let newList = []
              for (let i = 0; i < res[0].ZhangTingShuJu.length; i++) {
                  let item = res[0].ZhangTingShuJu[i]
                  item['blockInfo'] = this.blockFormat(item['SuoShuBanKuai'])
                  if(item.hasOwnProperty('BanKuaiDaiMa')) {
                      var names = item['SuoShuBanKuai'].split(',')
                      var codes = item['BanKuaiDaiMa'].split(',')
                      if(names.length == codes.length) {
                          for(var b=0;b<names.length;b++) {
                              this.blockCodes[names[b]] = codes[b]
                          }
                      }
                  }
                  newList.push(item)
              }
              this.navContents[index].tableList = [...newList]
              this.noData=false;
          }else{
              this.noData=true;
          }
          this.curNav = index
          //涨停原因
          this.getLimitUpReason(index)
      },
      getLimitUpReason: function(index){
          let self = this
          let date = this.nowDate.substring(0,4)+this.nowDate.substring(5,7)+this.nowDate.substring(8,10)
          let url = window.Bk_Server+'/api/date'
          axios.get(url,{
              params: {
                  date: date
              }
          }).then(response => {
              let res = response.data;
              self.navContents[index].init = true
              if(res.Result.length === 0) {
                  self.showReason = false
                  $('.table-zttj').css('width', '22rem')
              } else {
                  self.showReason = true
                  $('.table-zttj').css('width', '26rem')
              }
              res.Result.forEach(v => {
                  self.$set(self.reasons, v.stockcode, v.upreason)
              })
          });
      },
      filterFun:function(index,item){
          if(index>=0){
              this.navContents[this.curNav].upTopStock.filterCount=0
          }
          for(let i=0;i<this.navContents.length;i++){
              for(let j=0;j<this.navContents[i].rTableHeads.length;j++){
                  if(j!=index){
                      this.navContents[this.curNav].rTableHeads[j].filterCount=0
                  }
              }
          }
          if(item.filterCount==0){
              if(index == -1) {
                  item.filterCount=1
                  this.sort2(this.headers[index+1])
              } else {
                  item.filterCount=1
                  //this.sort(this.headers[index+1])
                  this.sort3(this.headers[index+1],1)
              }
          }else if(item.filterCount==1){
              item.filterCount=-1
             // this.reverse()
              this.sort3(this.headers[index+1],-1)
          }else{
              item.filterCount=0
              //this.sort('ZhangTingShiJian')
              this.sort3('ZhangTingShiJian',-1)
          }
      },
      sort3(key,desc){
          let arrOne=[]
          let arrTwo=[];
          this.navContents[this.curNav].tableList.forEach(v=> {
              if(v[key]==undefined && v[key]==null){
                  arrTwo.push(v)
              }else{
                  arrOne.push(v)
              }
          })
          if(desc==1){
              arrOne.sort(function(a,b){
                  var x = parseFloat(a[key]);
                  var y = parseFloat(b[key]);
                  return x - y;
              })
          }else{
              arrOne.sort(function(a,b){
                  var x = parseFloat(a[key]);
                  var y = parseFloat(b[key]);
                  return y - x;
              })
          }
          this.navContents[this.curNav].tableList=arrOne.concat(arrTwo);
      },
      sort(key){
          this.navContents[this.curNav].tableList.sort(function(a,b){
              var x = parseFloat(a[key]);
              var y = parseFloat(b[key]);
              return ((x<y)?-1:(x>y)?1:0)
          })
      },
      sort2(key){
          this.navContents[this.curNav].tableList.sort(function(a,b){
              var x = parseInt(a[key].substring(2,8));
              var y = parseInt(b[key].substring(2,8));
              return ((x<y)?-1:(x>y)?1:0)
          })
      },
      reverse(){
          this.navContents[this.curNav].tableList.reverse();
      },
      dataFormat:function (value, fmt) {
          let getDate = new Date(value);
          let o = {
              'M+': getDate.getMonth() + 1,
              'd+': getDate.getDate(),
              'h+': getDate.getHours(),
              'm+': getDate.getMinutes(),
              's+': getDate.getSeconds(),
              'q+': Math.floor((getDate.getMonth() + 3) / 3),
              'S': getDate.getMilliseconds()
          };
          if (/(y+)/.test(fmt)) {
              fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
          }
          for (let k in o) {
              if (new RegExp('(' + k + ')').test(fmt)) {
                  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
              }
          }
          return fmt;
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/calendar/Calendar.vue